<template>
  <div class="company-table">
    <!-- 标题区域 -->
    <div class="left-bg-title bg-center pd10tb">溯源企业</div>
    <!-- 表格区域 -->
    <table>
      <tr>
        <th>企业名称</th>
        <th>大类</th>
        <th>二级分类</th>
        <th>产品名称</th>
        <th>赋码统计</th>
        <th>扫码统计</th>
        <th>累计扫码占比</th>
      </tr>
      <tr v-for="item in tablist" class="animated infinite flipInX">
        <td class='td-company-name'>{{item.org_name}}</td>
        <td>{{item.category_name}}</td>
        <td>{{item.category_sub_name}}</td>
        <td class="p_name">
			<template v-for="items in item.p_name">
				{{items}}<br/>
			</template>
		</td>
        <td>{{String(item.unique_code).length >= 5 ? Math.round(item.unique_code/10000)+'万' : item.unique_code}}</td>
        <td>{{String(item.scan_code).length >= 5 ? Math.round(item.scan_code/10000)+'万' : item.scan_code}}</td>
        <td>{{item.codePlan}}%</td>
      </tr>
    </table>
  </div>
</template>

<script>
import {mapState} from "vuex"
export default {
	data(){
		return {
			tablist:null,
		}
	},
	computed:{
		...mapState(['syEnterpriseList']),
	},
	mounted() {
		this.checkList();
	},
	methods:{
		checkList() {
			let list = this.syEnterpriseList;
			let max = [];
			list && list.forEach(item => {
				if(item.p_name)
				{
					item.p_name = item.p_name.split(",")
				}
			});
			
			for(let i = 0; i <list.length; i++) {
				for(let j = i; j < list.length; j++) {
					if(list[i].scan_code < list[j].scan_code) {
						max = list[j];
						list[j] = list[i];
						list[i] = max;
					}
				}
			}
			console.log('排序',list)
			this.tablist = list;
		}	
	}
};
</script>

<style lang='less'>
//引入主色调样式
@import "../../assets/css/mainColor.less";
.company-table {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  table,
  th,
  td {
    border: 1px solid #25373a;
  }
  //表格样式
  table {
    width: 100%;
    margin: 10px auto;
    table-layout:initial;
    display: table;
    th,
    td {
      display: table-cell;
      padding: 10px 15px;
      color: @mainColor;
      text-align: center;
      cursor: pointer;
     
      white-space: nowrap;
    }
    .td-company-name {
      width: 100px;  
    }
  }
  //修改滚动条样式
  &::-webkit-scrollbar {
    border-radius: 10px;
    width: 10px;
    background-color: #25373a;
    height: 10px;
  }
  //修改滚动条内部小方块样式
  &::-webkit-scrollbar-thumb {
    background-color: #4FCCFF;
    border-radius: 10px;
  }
}
.p_name{
	line-height: 25px;
}
/* .animated {
	-webkit-animation-duration: 3s;
	animation-duration: 3s;
	-webkit-animation-fill-mode: both;
	animation-fill-mode: both
}

.animated.infinite {
	-webkit-animation-iteration-count: infinite;
	animation-iteration-count: infinite
}

.animated.hinge {
	-webkit-animation-duration: 2s;
	animation-duration: 2s
}

.animated.bounceIn,.animated.bounceOut,.animated.flipOutX,.animated.flipOutY {
	-webkit-animation-duration: .75s;
	animation-duration: .75s
}
@-webkit-keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}

	0%,40% {
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}

	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg)
	}

	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}

	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}

	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

@keyframes flipInX {
	0% {
		-webkit-transform: perspective(400px) rotateX(90deg);
		transform: perspective(400px) rotateX(90deg);
		opacity: 0
	}

	0%,40% {
		-webkit-animation-timing-function: ease-in;
		animation-timing-function: ease-in
	}

	40% {
		-webkit-transform: perspective(400px) rotateX(-20deg);
		transform: perspective(400px) rotateX(-20deg)
	}

	60% {
		-webkit-transform: perspective(400px) rotateX(10deg);
		transform: perspective(400px) rotateX(10deg);
		opacity: 1
	}

	80% {
		-webkit-transform: perspective(400px) rotateX(-5deg);
		transform: perspective(400px) rotateX(-5deg)
	}

	to {
		-webkit-transform: perspective(400px);
		transform: perspective(400px)
	}
}

.flipInX {
	-webkit-backface-visibility: visible!important;
	backface-visibility: visible!important;
	-webkit-animation-name: flipInX;
	animation-name: flipInX
} */
</style>